import * as React from 'react';
import { css } from 'aphrodite/no-important';
import { Helmet } from 'react-helmet';
import { AMPMediaBaseProps } from './AMPMedia.utils';

export const AMPSoundclound: React.FunctionComponent<AMPMediaBaseProps> = props => {
  const { mediaId, additionalStyle } = props;
  return (
    <React.Fragment>
      <Helmet>
        <script async={undefined} custom-element="amp-soundcloud" src="https://cdn.ampproject.org/v0/amp-soundcloud-0.1.js" />
      </Helmet>
      <figure className={css(additionalStyle.style)}>
        {/*
         // @ts-ignore TS2339 */}
        <amp-soundcloud width="16" height="9" layout="responsive" data-trackid={mediaId} data-visual="true" />
      </figure>
    </React.Fragment>
  );
};
